import { render, staticRenderFns } from "./models.vue?vue&type=template&id=9a56d758"
import script from "./models.vue?vue&type=script&lang=js"
export * from "./models.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports